import { nanoid } from 'nanoid';

import { stringToSha256 } from './utils';

export interface PKCE {
	verifier: string;
	challenge: string;
	method: 'S256';
}

/** Generate a PKCE verifier/challenge pair. */
export const generatePKCE = async (): Promise<PKCE> => {
	const verifier = nanoid(64);

	return {
		verifier: verifier,
		challenge: await stringToSha256(verifier),
		method: 'S256',
	};
};
